import { get } from 'lodash'
import routes from '~/const/routes'

export const state = () => ({
  items: [],
  meta: {
    totalItems: null
  },
  requestParams: null
})

export const getters = {
  items: state => state.items,
  meta: state => state.meta,
  requestParams: state => state.requestParams
}

export const mutations = {
  RESET(state) {
    state.items = []
    state.meta = { totalItems: null }
    state.requestParams = null
  }
}

export const actions = {
  async getAll({ commit }, { config = {} }) {
    const { data, meta } = get(await this.$axios.get(routes.template.list(), config), 'data')

    commit(
      'AFTER_GET_ALL',
      {
        namespace: 'templates',
        items: data,
        meta,
        params: config.params
      },
      { root: true }
    )

    return { data, meta }
  },
  async read({ commit }, { id, config }) {
    const template = get(await this.$axios.get(routes.template.concrete(id), config), 'data')
    commit('AFTER_READ', { namespace: 'templates', item: template }, { root: true })
    return template
  },
  async create({ commit }, { payload = {}, config = {} }) {
    const data = get(await this.$axios.post(routes.template.list(), payload, config), 'data')
    commit(
      'AFTER_CREATE',
      {
        namespace: 'templates',
        item: data
      },
      { root: true }
    )
    return data
  },
  async update({ commit }, { id, payload = {}, config = {} }) {
    const data = get(await this.$axios.put(routes.template.concrete(id), payload, config), 'data')
    commit(
      'AFTER_UPDATE',
      {
        namespace: 'templates',
        item: data
      },
      { root: true }
    )
    return data
  },
  async delete({ commit }, { id, config = {} }) {
    const response = await this.$axios.delete(routes.template.concrete(id), config)
    commit('AFTER_DELETE', { namespace: 'templates', id }, { root: true })
    return response
  },
  createField({ commit }, { templateId, payload = {} }) {
    return this.$axios.post(routes.template.fields(templateId), payload)
  },
  updateField({ commit }, { templateId, fieldId, payload = {} }) {
    return this.$axios.put(routes.template.concreteFields(templateId, fieldId), payload)
  },
  deleteField({ commit }, { templateId, fieldId }) {
    return this.$axios.delete(routes.template.concreteFields(templateId, fieldId))
  },
  createDocumentFromTemplate({ commit }, { templateId, payload = {} }) {
    return this.$axios.post(routes.template.toDocument(templateId), payload)
  },
  aiGenerate({ commit }, { templateId, payload = {} }) {
    return this.$axios.post(routes.template.aiGenerate(templateId), payload)
  }
}
